
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import InputText from '@/components/molecules/InputText.vue'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'

/**
 * 塾情報モーダルのフォーマット
 */
@Component({
  components: {
    ModalWindow,
    LabelBase,
    InputText,
    ButtonSubmit,
  },
})
export default class ModalAcademyData extends Vue {
  /** モーダル分子 */
  @Ref()
  modalWindow!: ModalWindow

  /** 登録/編集の切り替え(登録ならtrue) */
  @Prop({ default: true })
  private isRegistMode!: boolean

  /** 送信ボタンのDisabled制御 */
  @Prop()
  private submitDisabled!: (academyName: string, academyCode: string) => boolean

  /** 確認ボタン押下時のイベント */
  @Prop()
  private eventSubmit!: () => void

  /** 塾名 */
  public academyName: string = ''

  /** 塾コード */
  public academyCode: string = ''

  /**
   * 送信ボタンのDisabled制御
   *   入力値の変更を検知するため、getterでラップする
   *
   * @returns 塾名か塾コードが未入力ならtrue
   */
  private get disabled(): boolean {
    return this.submitDisabled(this.academyName, this.academyCode)
  }

  /**
   * モーダルを開く
   *
   * @param academyName ニックネーム
   */
  public show(academyName?: string): void {
    // モーダルを開く際に各項目を初期化(引数がある場合は代入)
    this.academyName = academyName || ''
    this.academyCode = ''
    this.modalWindow.show()
  }

  /**
   * モーダルを閉じる
   */
  public hide(): void {
    this.modalWindow.hide()
  }
}
